import { h, type FunctionalComponent } from '@stencil/core';
import type { IProductsList } from '../../../types/subcomponents-types.type';
import { SearchResultTag } from '../../../search-result-tag/search-result-tag';
import type { SearchProduct } from '../../../../../../../api/SearchApi';
import { DashboardItemHeader } from '../../dashboard-item-header/dashboard-item-header';
import {EolDiscontinuedResultList} from '../../../eol-discontinued-result-list/eol-discontinued-result-list';

export const DashboardProductsList: FunctionalComponent<IProductsList> = ({
  ...props
}) => {
    const getProducts = (
      products: SearchProduct[],
      limit: number
    ): Array<any> => {//eslint-disable-line @typescript-eslint/no-explicit-any
        if (products && limit) {
          return products.slice(0, limit);
        }
        return products;
    };

    const resultIndexOffset = props.eolDiscontinuedResults?.documents?.length || props.eolDiscontinuedResults?.documentsGroup?.length || 0;

    return (
      <div class="dashboard__tiles--mobile dashboard-minus-margins">
        <div class={{
          'dashboard-products-list': true,
        }}>
          {props?.mobileView ? (
            <div class="dashboard-products-list__section">
              <DashboardItemHeader
                title={props.labelProvider(`tab.${props.tabName}`, 'Products')}
                labelProvider={(e, f) => props.labelProvider(e, f)}
                targetTab={props.targetTab}
                tabCount={props.tabCount}
                subTitle={props.subTitle}
                privateCard={false}
                mobileView={true}
                itemCount={props.docLimit}
              />
            </div>
          ) : (
            <div class="dashboard-products-list__title">
              {props.labelProvider(`tab.${props.tabName}`, 'Products')}
            </div>
          )}

          {props.priceBanner ? <div class="eol-result-list--dashboard"><uiaas-search-widget-cta-banner
            slot="before-results"
            url="/myschneider/priceAndAvailability"
            fluid={true}
            label={props.labelProvider(
              'redirection.banner.widget.paTool',
              'Please refer to our <b>Price and Availability tool</b> ' +
              'for quick, precise insights into product pricing and availability.')}
            heading={props.labelProvider('redirection.banner.widget.paHeading', 'Discover product pricing and availability!')}
            cta={props.labelProvider('redirection.banner.widget.cta', 'Explore')}
            icon="box2"
          /></div> : ''}          
          
          <uiaas-search-widget-additional-conditions-banner
            isProductTabVariant={false}
            labelProvider={(e, f) => props.labelProvider(e, f)}
            term={props.term}
            isAdditionalConditionsWidgetActive={props.isAdditionalConditionsWidgetActive}
            isMiaPromotionWidget={props.isMiaPromotionWidget}
            miaData={props.miaData}
            isMySeVersion={props.isMySeVersion}
          >
          </uiaas-search-widget-additional-conditions-banner>

          <div class="eol-result-list--dashboard">
            <EolDiscontinuedResultList
              loading={false}
              tabular={false}
              mobileView={props.mobileView}
              isSubstitutionTool={props.isSubstitutionTool}
              eolDiscontinuedResults={props.eolDiscontinuedResults}
              labelProvider={props.labelProvider}
              tabName={props.tabName}
              strategies={props.strategies}
              rtl={props.rtl}
              term={props.term}
              language={props.language}
              country={props.country}
            />
          </div>
          <section>
            {getProducts(props.products, props.docLimit)?.map((doc, index) => {
                if (props.mobileView) doc.description = ''; // change it
                return (
                  <div class="dashboard-products-list__item">
                    <SearchResultTag
                      doc={doc as unknown as SearchProduct}
                      index={index + resultIndexOffset}
                      resultRenderer={props.resultRenderer}
                      labelProvider={(e, f) => props.labelProvider(e, f)}
                      country={props.country}
                      language={props.language}
                      gridView={false}
                      isEcommerceMode={props.isEcommerceMode}
                      eShop={props.eShop}
                      rtl={props.rtl}
                      strategies={props.strategies}
                      resultClickAnalytics={props.resultClickAnalytics}
                      isDashboardView={true}
                      isDashboardListVariant={props.isDashboardListVariant}
                      lazyLoadImages={props.lazyLoadImages}
                      isSubstitutionTool={props.isSubstitutionTool}
                      eolProductsNumber={resultIndexOffset}
                      wcEventData={props.wcEventData}
                      isUnifiedCheckout={props.isUnifiedCheckout}
                    />
                  </div>
                );
            })}
          </section>
          {props.mobileView ? (
            <uiaas-dashboard-tab-button
              labelProvider={(e, f) => props.labelProvider(e, f)}
              targetTab={props.targetTab}
              tabCount={props.tabCount}
              tabName={props.tabName}
              mobileView={true}
            />
          ) : (
            ''
          )}
        </div>
      </div>
    );
};
